import {Request} from 'citrus.plugins.request';

export class VuexSettingsRestClient {
	constructor() {
		this.request = new Request();
		this.request.setModeModule();

		return this;
	}

	load() {
		return this.request
				.setAction('citrus:restsale.api.grid.load')
				.send()
		;
	}

	setView(type) {
		return this.request
			.setAction('citrus:restsale.api.grid.setViewType')
			.setData({type: type})
			.send()
		;
	}

	setSort(type) {
		return this.request
			.setAction('citrus:restsale.api.grid.setSort')
			.setData({type: type})
			.send()
			;
	}

	setPageCount(type) {
		return this.request
			.setAction('citrus:restsale.api.grid.setPageCount')
			.setData({elementCount: type})
			.send()
			;
	}

	setAvailable(available) {
		return this.request
			.setAction('citrus:restsale.api.grid.setAvailable')
			.setData({available: available ? 'Y' : 'N'})
			.send()
			;
	}
}
